export const arrayOfDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
export const arrayOfTimesGeneral = [
  { value: 9, displayValue: '09:00' },
  { value: 9.5, displayValue: '09:30' },
  { value: 10, displayValue: '10:00' },
  { value: 10.5, displayValue: '10:30' },
  { value: 11, displayValue: '11:00' },
  { value: 11.5, displayValue: '11:30' },
  { value: 12, displayValue: '12:00' },
  { value: 12.5, displayValue: '12:30' },
  { value: 13, displayValue: '13:00' },
  { value: 13.5, displayValue: '13:30' },
  { value: 14, displayValue: '14:00' },
  { value: 14.5, displayValue: '14:30' },
  { value: 15, displayValue: '15:00' },
  { value: 15.5, displayValue: '15:30' },
  { value: 16, displayValue: '16:00' },
  { value: 16.5, displayValue: '16:30' },
  { value: 17, displayValue: '17:00' },
  { value: 17.5, displayValue: '17:30' },
  { value: 18, displayValue: '18:00' },
  { value: 18.5, displayValue: '18:30' },
  { value: 19, displayValue: '19:00' }
]

const daysInAlbanian = {
  Monday: 'Hën',
  Tuesday: 'Mar',
  Wednesday: 'Mër',
  Thursday: 'Enj',
  Friday: 'Pre',
  Saturday: 'Sht',
  Sunday: 'Die'
}

export const thisWeekGenerator = (selectedDate) => {
  const today = selectedDate || new Date()
  const day = today.getDay()

  const date = today.getDate()
  const month = today.getMonth()
  const year = today.getFullYear()
  const week = []
  for (let i = 1; i < 7; i++) {
    week.push(new Date(year, month, date + i - day))
  }
  const sortedWeek = week.slice(0).map((day, idx) => {
    return {
      // day: day.toDateString().split(' ')[0],
      day: daysInAlbanian[arrayOfDays[idx]],
      fullDate: `${day.getFullYear()}-${day.getMonth() + 1 < 10 ? `0${day.getMonth() + 1}` : day.getMonth() + 1}-${
        day.getDate() < 10 ? `0${day.getDate()}` : day.getDate()
      }`,
      isToday: day.toDateString() === today.toDateString()
    }
  })
  return sortedWeek
}

export const isCurrentTimeInRange = (current, startTime, endTime) => {
  try {
    const [startHours, startMinutes] = startTime.split(':').map(Number)
    const [endHours, endMinutes] = endTime.split(':').map(Number)
    const start = new Date()
    start.setHours(startHours, startMinutes, 0, 0)
    const end = new Date()
    end.setHours(endHours, endMinutes, 0, 0)
    return current >= start && current < end
  } catch (error) {
    return false
  }
}

export const thisWeek = thisWeekGenerator()

export function groupAppointments(appointments) {
  const sorted = [...appointments].sort((a, b) => a.from - b.from || b.to - b.from - (a.to - a.from))
  if (sorted.length === 0) {
    return []
  }
  const groups = [
    {
      from: sorted[0].from,
      to: sorted[0].to,
      appointments: [sorted[0]]
    }
  ]
  sorted.slice(1).forEach((appointment) => {
    const lastGroup = groups[groups.length - 1]
    if (appointment.from < lastGroup.to) {
      lastGroup.to = Math.max(lastGroup.to, appointment.to)
      lastGroup.appointments.push(appointment)
    } else {
      groups.push({
        from: appointment.from,
        to: appointment.to,
        appointments: [appointment]
      })
    }
  })
  return groups
}

export const generateTimeSpanArray = (arrayOfTimes, arrayOfAppointments) => {
  const result = []
  const groups = groupAppointments(arrayOfAppointments)
  for (let i = 0; i < arrayOfTimes.length; ) {
    const time = arrayOfTimes[i]
    const group = groups.find((group) => group?.from <= time?.value && group?.to > time?.value)
    if (group) {
      const consideredSpan = group.to - group.from
      const usedSpan = consideredSpan === 0.5 ? 1 : consideredSpan * 2
      result.push({
        fullspan: usedSpan,
        from: group.from,
        to: group.to,
        appointments: group.appointments.map((appointment) => appointment.id)
      })
      i += usedSpan
    } else {
      result.push({
        fullspan: 1,
        from: time.value,
        to: time.value + 0.5,
        appointments: []
      })
      i++
    }
  }

  return result
}

export const splitMMDD = (date) => {
  const [, month, day] = date.split('-')
  return month && day ? day + '/' + month : ''
}

export const convertNumberToTime = (number) => {
  const hours = Math.floor(number)
  const minutes = (number - hours) * 60
  return `${hours}:${minutes === 0 ? '00' : minutes}`
}
